const taq = ['Manage Tags'];
const prints = (status) => {
    switch (status) {
        case 'awaiting-payment':
            return (['print']);
        case 'on-hold':
            return (['print']);
        case 'awaiting-shipment':
            return (['Packing Slip'])//,'Label','Customs Form','Order Summary'
        case 'shipped':
            return (['print']);
        case 'cancelled':
            return (['print']);
        default:
            return (['print']);
    };
}
    const assignTo = ['assign to'];
    const hold = ['hold'];
    const bulkUpdate = ['bulkUpdate'];
    const createPlusPrintLabel = ['Create Label'];
    const allocate = ['allocate'];

    const other = (status) => {
        switch (status) {
            case 'awaiting-payment':
                return (['Export Orders', 'Cancel']); 
            case 'on-hold':
                return (['Export Orders', 'Cancel']); 
            case 'awaiting-shipment':
                return (['Export Orders', 'Cancel']); 
            case 'shipped':
                return (['Export Orders', 'Cancel']); 
            case 'cancelled':
                return (['Export Orders']);
            default:
                return '';
        }
    }

    const columnCustomize =[
        'name',
        'orderNo',
        'age',
        'city',
        'state',
        'zipCode',
        'country',
        'store',
        'paidDate',
        'shipDate',
        'shippingPaid',
        'taxPaid',
        'totalPaid',
        'quantity'
    ]

    const DropDown = (status) => {
        const otherActions = other(status);
        const print = prints(status);
        switch (status) {
            case 'awaiting-payment':
                return {
                    taq,
                    print,
                    assignTo,
                    hold,
                    bulkUpdate,
                    otherActions,
                    columnCustomize
                };
            case 'on-hold':
                return {print, assignTo, taq, bulkUpdate, otherActions,columnCustomize};
            case 'awaiting-shipment':
                return {
                    createPlusPrintLabel,
                    print,
                    assignTo,
                    taq,
                    bulkUpdate,
                    allocate,
                    otherActions,
                    columnCustomize
                };
            case 'shipped':
                return {print, assignTo, taq, bulkUpdate, otherActions,columnCustomize};
            case 'cancelled':
                return {print, assignTo, taq, bulkUpdate, otherActions,columnCustomize};
            default:
                return '';
        }
    }
    export default DropDown;